import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { isLoggedOnSelector } from '../selectors/isLoggedOnSelector';
import { jobInfoAtom } from '../atoms/jobInfoAtom';

export const useUpdateDummyCustomerDoB = (): {
    updateDummyCustomerDoB: (cprNumber: string) => Promise<void>;
} => {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);

    const isLoggedOn = useRecoilValue(isLoggedOnSelector);
    const updateDummyCustomerDoB = async (cprNumber: string): Promise<void> => {
        await OnlineSalesUnauthenticated.updateDummyCustomerDoB(
            jobNumber,
            cprNumber,
            sessionId,
            !isLoggedOn
        );
    };

    return { updateDummyCustomerDoB };
};
